import { EntityModel } from '@/interfaces'
import {
  ALL_BUSFINDER_BLOCKS_QUERY,
  CREATE_BUSFINDER_BLOCK_MUTATION,
  DELETE_BUSFINDER_BLOCK_MUTATION,
  FORCE_DELETE_BUSFINDER_BLOCK_MUTATION,
  SINGLE_BUSFINDER_BLOCK_QUERY,
  UPDATE_BUSFINDER_BLOCK_MUTATION,
} from './graphql'

const cmsBusfinderBlockModel: EntityModel = {
  name: 'busfinderBlock',
  namePlural: 'busfinderBlocks',
  uniqueName: 'cmsBusfinderBlock',
  uniqueNamePlural: 'cmsBusfinderBlocks',
  path: 'cms/blocks/busfinder_block',
  baseUrl: '/cms/blocks/busfinder_blocks',
  translationPrefix: 'entities:cmsBusfinderBlock.',
  getDisplayName: (values: any) => {
    return 'BUSFINDER BLOCK'
  },
  gql: {
    getAll: ALL_BUSFINDER_BLOCKS_QUERY,
    getSingle: SINGLE_BUSFINDER_BLOCK_QUERY,
    create: CREATE_BUSFINDER_BLOCK_MUTATION,
    update: UPDATE_BUSFINDER_BLOCK_MUTATION,
    delete: DELETE_BUSFINDER_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_BUSFINDER_BLOCK_MUTATION,
  },
  attributes: {
    title: {
      name: 'title',
      label: 'entities:cmsBusfinderBlock.attributes.title.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsBusfinderBlockModel
